import gql from 'graphql-tag';

// The leaf one-of selections, factored out so they can be spread at the top level and at each
// level of `matchesRelatedEntity`. GraphQL fragments can't recurse, which is why every nested
// level is spelled out rather than reusing `FilterByComponent` - so the number of levels written
// in `FilterByComponent` *is* the nesting depth the app supports (see `RELATED_ENTITY_MAX_DEPTH`),
// even though the schema type nests without limit.
export const FilterOneOfFields = gql`
  fragment FilterOneOfFields on FilterOneOfObject {
    stringWildcard {
      value
    }
    containsNumber {
      values
      negate
    }
    containsString {
      values
      negate
    }
    dateIs {
      operator
      relativeDate {
        duration
        timeUnit
      }
    }
    dateRange {
      before
      after
    }
    dateTokenIs {
      value
    }
    numberIs {
      operator
      value
    }
    isEmpty {
      value
    }
    containsCurrentUser {
      value
    }
    booleanIs {
      operator
      value
    }
  }
`;

// The same leaves again, for the dynamic union. `DynamicFilterOneOfObject` is a type of its own -
// every branch of `FilterOneOfObject` plus `containsCurrentWorkflowTemplateComponentValue`, the
// one that defers to a field on the card being edited - and a fragment on one type can't be
// spread into the other, so the shared branches have to be restated here.
//
// Keep the two in step. A related card component's `listDefault` is read through this fragment
// and written back whole, so a branch it doesn't select is dropped from stored filters on the
// next save of that field - whether or not the save had anything to do with filtering.
export const DynamicFilterOneOfFields = gql`
  fragment DynamicFilterOneOfFields on DynamicFilterOneOfObject {
    stringWildcard {
      value
    }
    containsNumber {
      values
      negate
    }
    containsString {
      values
      negate
    }
    dateIs {
      operator
      relativeDate {
        duration
        timeUnit
      }
    }
    dateRange {
      before
      after
    }
    dateTokenIs {
      value
    }
    numberIs {
      operator
      value
    }
    isEmpty {
      value
    }
    containsCurrentUser {
      value
    }
    booleanIs {
      operator
      value
    }
    containsCurrentWorkflowTemplateComponentValue {
      componentId
    }
  }
`;
